var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.846,
    height: 24,
    viewBox: "0 0 25.846 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check2-circle",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3523",
    "data-name": "Pfad 3523",
    d: "M3.346,13.5a10.153,10.153,0,0,1,15.23-8.795.923.923,0,1,0,.923-1.6,12,12,0,1,0,6,10.393.923.923,0,1,0-1.846,0,10.153,10.153,0,0,1-20.307,0Z",
    transform: "translate(-1.5 -1.499)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3524",
    "data-name": "Pfad 3524",
    d: "M24.538,4.077A.924.924,0,1,0,23.231,2.77L10.962,15.041,6.077,10.154A.924.924,0,0,0,4.77,11.461L10.308,17a.923.923,0,0,0,1.307,0Z",
    transform: "translate(1.038 -0.653)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.d4ad74c9.svg";
export { ForwardRef as ReactComponent };